import { useNavigate, useLocation, useParams } from "react-router-dom";
import TableManager from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES, VAR_TYPES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent, statusTypes, tagList } from "utils/boHelper";
import Button from "core/buttons/button/Button";
import { FormattedMessage } from "react-intl";
import { useSettingsContext } from "api/settings/SettingsProvider";
import { useState, useEffect } from "react";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useCountryContext } from "api/settings/country/CountryProvider";
import { formatValueDate } from "utils/functions";
import { useUserContext } from "api/user/UserProvider";

export default function AdminDoc({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    BODocList,
    postBoDoc,
    getAllBoDocs,
    getBoDoc,
    deleteDoc,
    editBoDoc,
    editBoFile,
    BODoc,
  } = useSettingsContext();
  const { lang } = useUserContext();
  const { countryListGetter, countryList } = useCountryContext();
  const { id } = useParams();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (id) {
      getBoDoc(id);
    }
  }, [id]);


  const choices = [{ name: "", value: null }].concat(
    countryList.map((e) => ({
      name: e.name,
      value: e.id,
    }))
  );

  const docForm = [
    {
      col: "country_id",
      mandatory: true,
      isMissingValue: null,
      options: countryList?.map((c) => c.name),
      type: VAR_TYPES.DROPDOWN,
      choices,
      value: id ? countryList?.map((c) => c.name)[0] : null,
    },
    { col: "file_name", mandatory: true, isMissingValue: null },
    { col: "label_fr", mandatory: true, isMissingValue: null },
    { col: "label_en", mandatory: true, isMissingValue: null },
    {
      col: "default_document",
      mandatory: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: statusTypes,
    },
    {
      col: "tag",
      mandatory: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: tagList,
    },
    {
      col: "status",
      mandatory: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: statusTypes,
    },
    {
      col: "file",
      mandatory: false,
      isMissingValue: null,
      type: "file",
    },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    countryListGetter();
    getAllBoDocs();
    setRefresh(false);
  }, [refresh]);

  const formatBODocList = (list) => {
    return list?.map((e) => ({
      ...e,
      country_id: countryList?.find((c) => c.id === e.country_id)?.name,
      status: e.status ? "true" : "false",
      default_document: e.default_document ? "true" : "false",
    }));
  };

  const formatEntityPerId = (BODoc) => {
    return {
      ...BODoc,
      status: BODoc?.status ? "true" : "false",
      default_document: BODoc?.default_document ? "true" : "false",
      country_id: countryList?.find((c) => c.id === BODoc?.country_id)?.name,
      updated_at: formatValueDate({ date: BODoc?.updated_at, lang: lang }),
      created_at: formatValueDate({ date: BODoc?.created_at, lang: lang }),
    };
  };

  const handleDelete = async (id) => {
    setDeleteData(BODocList.find((e) => e.id === id));
  };
  const validateDelete = async (BODocId) => {
    try {
      await deleteDoc(BODocId);
      setRefresh(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCreate = async (payload) => {
    const countryId = getCountryIdFromName(payload?.country_id);
    const formData = new FormData();
    formData.append("country_id", countryId);
    formData.append("status", payload.status === "true");
    formData.append("default_document", payload.default_document === "true");
    payload?.file && formData.append("file", payload.file?.target?.files[0]);
    formData.append("label_fr", payload.label_fr);
    formData.append("label_en", payload.label_en);
    formData.append("tag", payload.tag);
    formData.append("file_name", payload.file_name);
    try {
      await postBoDoc(formData);
      navigateToParent(navigate, location);
      setRefresh(true);
    } catch (e) {
      console.error(e);
    }
  };

  const getCountryIdFromName = (countryName) => {
    const country = countryList.find((c) => c.name === countryName);
    return country ? country.id : Number(countryName);
  };

  const handleEdit = async (payload) => {
    const countryId = getCountryIdFromName(payload?.country_id);
    try {
      await editBoDoc(payload.id, {
        ...payload,
        country_id: countryId,
        status: payload.status === "true",
        default_document: payload.default_document === "true",
        file: null,
      });
      if (payload?.file?.target?.files[0]) {
        await editBoFile(payload.id, sendFile(payload));
      }
      navigateToParent(navigate, location);
      setRefresh(true);
    } catch (e) {
      console.error(e);
    }
  };

  const sendFile = (payload) => {
    const formData = new FormData();
    formData.append("file", payload.file?.target?.files[0]);
    return formData;
  };

  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.DOCUMENT}
        entityPerId={formatEntityPerId(BODoc)}
        list={BODocList?.length > 0 && formatBODocList(BODocList)}
        inputs={docForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        countryList={countryList}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.DOCUMENT}
        />
      </div>
    </div>
  );
}
